import { Injectable } from '@angular/core';
import { keys, keysUniversal, keysFixedRates } from '../../resources/keys.resources';
import * as CryptoJS from 'crypto-js';
import { Key } from 'selenium-webdriver';
import { GetJWTTokenService } from '../getJWTToken/get-jwttoken.service';
import { Observable } from 'rxjs';
import { PropertyDto } from 'src/app/models/universal.model';

@Injectable({
  providedIn: 'root'
})
export class StoreServiceLibrary {
  static isWebLogin = false;
  static application = '';
  static securityDevice = ''

  constructor() {
    StoreServiceLibrary.isWebLogin = false;
  }

  getStorage() {
    let storage: any;
    // if (StoreServiceLibrary.isWebLogin) {
    //   storage = sessionStorage;
    // } else {
    //   storage = localStorage;
    // }

    storage = localStorage;
    return storage;
  }


  decrypt(object) {
    let dataFromStorage: any;
    try {
      const bytes = CryptoJS.AES.decrypt(object, 'miclave');
      dataFromStorage = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (ex) {
      // console.log(ex);
    }
    return dataFromStorage;
  }

  public getItemFromStorage(key: string) {
    return this.decrypt(this.getStorage().getItem(key));
  }

  public setItemInStorage(key: string, object: any) {
    this.getStorage().setItem(key, CryptoJS.AES.encrypt(JSON.stringify(object), 'miclave').toString());
  }

  getStateApp() {
    return this.getItemFromStorage('STATE_APP');
  }

  setStateApp(stateApp: any) {
    this.setItemInStorage('STATE_APP', stateApp);
  }

  setOptionItemInStorage(keyStorage: string, keyItem: string | number, data: any) {
    const myStorageData: any = this.getItemFromStorage((keyStorage));
    myStorageData[keyItem] = data;
    this.setItemInStorage(keyStorage, myStorageData);
  }

  // getUserData(): UserData {
  //   let infoUser: UserData;

  //   infoUser = this.getItemFromStorage(keys.user) as UserData;

  //   if (!infoUser) {
  //     infoUser = new UserData();
  //   }
  //   return infoUser;
  // }

  // setUserData(user: UserData) {
  //   this.setItemInStorage(keys.user, user);
  // }

  setUniversalProperties(universalProperties: PropertyDto[]) {
    this.setItemInStorage(keys.universalProperties, universalProperties);
  }

  getAllUniversalProperties(): PropertyDto[] {
    return this.getItemFromStorage(keys.universalProperties) as PropertyDto[];
  }

  getJustOneUniversalPropertie(keyPropertie: string): string {
    let mapProperties: PropertyDto[];
    mapProperties = this.getItemFromStorage(keys.universalProperties) as PropertyDto[];
    let valuePropertie = '';
    if (mapProperties) {
      const propertie: PropertyDto = mapProperties.find(thePropertie =>
        thePropertie.key === String(StoreServiceLibrary.application).concat(keyPropertie)
      );
      if (propertie) {
        valuePropertie = propertie.value;
      } else {
        valuePropertie = '';
      }
    }
    return valuePropertie;
  }

  clearStorage() {
    const storage: any = this.getStorage();

    // localStorage.clear();
    storage.removeItem(keys.user);
    storage.removeItem(keys.card_data);
    storage.removeItem(keys.travelClass);
    storage.removeItem(keys.travel_drive);
    storage.removeItem(keys.travel_flights);
    storage.removeItem(keys.travel_go_out);
    storage.removeItem(keys.travel_hotels);
    storage.removeItem(keys.detailTransaction);
    storage.removeItem(keys.myImages);
    storage.removeItem(keys.point);
    storage.removeItem(keys.actionsMessage);
    storage.removeItem(keys.points_porcentage);
    storage.removeItem(keys.vop_demo);
    storage.removeItem(keys.cardScotiaPointsSelected);
    storage.removeItem(keys.typeInstallments);
    storage.removeItem(keys.installments);
    storage.removeItem(keys.mustChargeUniversal);
    storage.removeItem(keys.responseGetAccount);
    storage.removeItem(keys.responseGetCreditCards);
    // storage.removeItem(keys.brandClass);
    // storage.removeItem(keys.idAplication);
  }

  // **** Card Data
  /**
   * Get Card Data information from the storage
   */
  getCardData() {
    return this.getItemFromStorage(keys.card_data);
  }
  /**
   * Save Card Data information into storage
   * @param: data
   */
  setCardData(data: any) {
    this.setItemInStorage(keys.card_data, data);
  }

  // **** Detail transaction
  /**
   * Get Detail transaction from the storage
   */
  getDetailTransaction() {

    return this.getItemFromStorage(keys.detailTransaction);
  }
  /**
   * Save Detail transaction into storage
   * @param: detailTransaction
   */
  setDetailTransaction(detailTransaction: any) {
    this.setItemInStorage(keys.detailTransaction, detailTransaction);
  }

  // **** Purchase
  /**
   * Clear info from the storage for idPurchse
   */
  clearPurchase() {
    this.getStorage().removeItem(keys.purchase);

  }
  /**
   * Return info from the storage the Purchase saved
   * @returns idPurchase
   */
  getPurchase() {
    return this.getStorage().getItem(keys.purchase);
  }
  /**
   * Save the purchase id into storage
   * @param: purchaseId
   */
  setPurchase(purchaseId: string) {
    this.getStorage().setItem(keys.purchase, purchaseId);
  }

  getPurchaseType() {
    return this.getStorage().getItem(keys.purchaseType);
  }
  setPurchaseType(type: string) {
    this.getStorage().setItem(keys.purchaseType, type);
  }
  clearPurchaseType() {
    this.getStorage().removeItem(keys.purchaseType);
  }

  getFlagVerifyProxyTravel(): boolean {
    return this.getStorage().getItem(keys.flagVerifyProxyTravel) as boolean;
  }
  setFlagVerifyProxyTravel(type: boolean) {
    this.getStorage().setItem(keys.flagVerifyProxyTravel, type);
  }
  clearFlagVerifyProxyTravel() {
    this.getStorage().removeItem(keys.flagVerifyProxyTravel);
  }


  getMustChargeUniversal(): boolean {
    return this.getStorage().getItem(keys.mustChargeUniversal) as boolean;
  }
  setMustChargeUniversal(mustChargeUniversal: boolean) {
    this.getStorage().setItem(keys.mustChargeUniversal, mustChargeUniversal);
  }
  clearMustChargeUniversal() {
    this.getStorage().removeItem(keys.mustChargeUniversal);
  }


  getWithoutToken(): boolean {
    return this.getStorage().getItem(keys.withoutToken) as boolean;
  }
  setWithoutToken(WithoutToken: boolean) {
    this.getStorage().setItem(keys.withoutToken, WithoutToken);
  }
  clearWithoutTokenl() {
    this.getStorage().removeItem(keys.withoutToken);
  }


  getTypeInstallments(): string {
    return this.getStorage().getItem(keys.typeInstallments) as string;
  }
  setTypeInstallments(type: string) {
    this.getStorage().setItem(keys.typeInstallments, type);
  }
  clearTypeInstallments() {
    this.getStorage().removeItem(keys.typeInstallments);
  }

  getInstallments(): string {
    return this.getStorage().getItem(keys.installments) as string;
  }
  setInstallments(installment: string) {
    this.getStorage().setItem(keys.installments, installment);
  }
  clearInstallments() {
    this.getStorage().removeItem(keys.installments);
  }

  getCardScotiaPointsSelected(): string {
    return this.getItemFromStorage(keys.cardScotiaPointsSelected) as string;
  }

  setCardScotiaPointsSelected(cardScotiaPointsSelected: string) {
    this.setItemInStorage(keys.cardScotiaPointsSelected, cardScotiaPointsSelected);
  }

  clearCardScotiaPointsSelected() {
    this.getStorage().removeItem(keys.cardScotiaPointsSelected);
  }


  // **** InfoPreferencePayment
  /**
   * Clear info from the storage to the InfoPreferencePayment
   */
  clearInfoPreferencePayment() {
    this.getStorage().removeItem(keys.infoPreferencePayment);
  }
  /**
   * Return info from the storage to the InfoPreferencePayment
   * @returns InfoPreferencePayment
   */
  getInfoPreferencePayment() {
    return this.getStorage().getItem(keys.infoPreferencePayment);
  }
  /**
   * Save the purchase id into storage
   * @param: infoPreferencePayment
   */
  setInfoPreferencePayment(infoPreferencePayment) {
    this.getStorage().setItem(keys.infoPreferencePayment, infoPreferencePayment);

  }

  // **** ProductToPurchase
  /**
   * Get Product information from the storage
   */
  getProductToPurchase() {
    return this.getItemFromStorage(keys.product);
  }

  /**
   * Save Product information into storage
   * @param: product
   */
  setProductToPurchase(product: any) {
    this.setItemInStorage(keys.product, product);
  }

  setInfoNotification(dataNotification: any) {
    this.setItemInStorage(keys.notification, dataNotification);
  }

  clearInfoNotification() {
    this.getStorage().removeItem(keys.notification);
  }

  // **** ActionsMessage
  getActionsMessage() {
    return this.getStorage().getItem(keys.actionsMessage);
  }
  setActionsMessage(action) {
    this.getStorage().setItem(keys.actionsMessage, action);
  }

  // **** Point
  /**
   * Get Point information from the storage
   */
  getPoint() {
    return this.getStorage().getItem(keys.point);

  }

  /**
   * Save Point information into storage
   * @param: point
   */
  setPonit(point) {
    this.getStorage().setItem(keys.point, point);
  }

  // **** NeedLogin
  // setNeedLogin() {
  //   const userData = this.getUserData();
  //   userData.needLogin = true;
  //   this.setUserData(userData);
  // }

  /**
   * Clear info from the storage for PointsPorcentage
   */
  clearPointsPorcentage() {
    this.getStorage().removeItem(keys.points_porcentage);
  }
  getPointsPorcentage(): string {
    return this.getItemFromStorage(keys.points_porcentage) as string;
  }
  setPointsPorcentage(goOutData: string) {
    this.setItemInStorage(keys.points_porcentage, goOutData);
  }
  //
  clearFlightTaxes() {
    this.getStorage().removeItem(keys.flightTaxes);
  }
  getFlightTaxes(): number {
    return this.getItemFromStorage(keys.flightTaxes) as number;
  }
  setFlightTaxes(taxes: number) {
    this.setItemInStorage(keys.flightTaxes, taxes);
  }
  //
  clearFixedRates() {
    this.getStorage().removeItem(keys.fixedRates);
  }
  getFixedRates(): number {
    return this.getItemFromStorage(keys.fixedRates) as number;
  }
  setFixedRates(fixedRates: number) {
    this.setItemInStorage(keys.fixedRates, fixedRates);
  }
  //
  clearProductFixedRates() {
    this.getStorage().removeItem(keys.productFixedRates);
  }
  getProductFixedRates(): any {
    return this.getItemFromStorage(keys.productFixedRates) as any;
  }
  setProductFixedRates(taxes: any) {
    this.setItemInStorage(keys.productFixedRates, taxes);
  }
  //
  clearObjSliderOP() {
    this.getStorage().removeItem(keys.objectSliderOP);
  }
  getObjSliderOP(): any {
    return this.getItemFromStorage(keys.objectSliderOP) as any;
  }
  setObjSliderOP(obj: any) {
    this.setItemInStorage(keys.objectSliderOP, obj);
  }
  //
  clearObjConfOnePocketBlue() {
    this.getStorage().removeItem(keys.objConfOnePocketBlue);
  }
  getObjConfOnePocketBlue(): any {
    return this.getItemFromStorage(keys.objConfOnePocketBlue) as any;
  }
  setObjConfOnePocketBlue(obj: any) {
    this.setItemInStorage(keys.objConfOnePocketBlue, obj);
  }
  //
  clearObjMopCryptmi() {
    this.getStorage().removeItem(keys.objectMopCryptmi);
  }
  getObjMopCryptmi(): any {
    return this.getItemFromStorage(keys.objectMopCryptmi) as any;
  }
  setObjMopCryptmi(obj: any) {
    this.setItemInStorage(keys.objectMopCryptmi, obj);
  }
  //
  clearObjPayWithVirtualCard() {
    this.getStorage().removeItem(keys.objPayWithVirtualCard);
  }
  getObjPayWithVirtualCard(): any {
    return this.getItemFromStorage(keys.objPayWithVirtualCard) as any;
  }
  setObjPayWithVirtualCard(obj: any) {
    this.setItemInStorage(keys.objPayWithVirtualCard, obj);
  }
  //
  clearResponseGetAccount() {
    this.getStorage().removeItem(keys.responseGetAccount);
  }
  getResponseGetAccount(): any {
    return this.getItemFromStorage(keys.responseGetAccount) as any;
  }
  setResponseGetAccount(obj: any) {
    this.setItemInStorage(keys.responseGetAccount, obj);
  }
  //
  clearResponseGetCreditCards() {
    this.getStorage().removeItem(keys.responseGetCreditCards);
  }
  getResponseGetCreditCards(): any {
    return this.getItemFromStorage(keys.responseGetCreditCards) as any;
  }
  setResponseGetCreditCards(obj: any) {
    this.setItemInStorage(keys.responseGetCreditCards, obj);
  }
  //
  clearCredicardTempUniqueMethod() {
    this.getStorage().removeItem(keys.credicardTemporalUniqueMethod);
  }
  getCredicardTempUniqueMethod(): any {
    return this.getItemFromStorage(keys.credicardTemporalUniqueMethod) as any;
  }
  setCredicardTempUniqueMethod(obj: any) {
    this.setItemInStorage(keys.credicardTemporalUniqueMethod, obj);
  }

  getIsSanbox(): boolean {
    return this.getItemFromStorage(keys.isSanbox) as boolean;
  }

  setIsSanbox(isSanbox: boolean) {
    this.setItemInStorage(keys.isSanbox, isSanbox);
  }

  getBrandClass(): string {
    return this.getItemFromStorage(keys.brandClass) as string;
  }

  setBrandClass(newBrandClass: string) {
    this.setItemInStorage(keys.brandClass, newBrandClass);
  }

  getIdAplication(): number {
    return this.getItemFromStorage(keys.idAplication) as number;
  }

  setIdAplication(newIdAplication: number) {
    this.setItemInStorage(keys.idAplication, newIdAplication);
  }

  getIsAuthenticateWithBiometric(): boolean {
    return this.getStorage().getItem(keys.isAuthenticateWithBiometric);
  }

  setIsAuthenticateWithBiometric(isAuthenticateWithBio: boolean) {
    this.getStorage().setItem(keys.isAuthenticateWithBiometric, isAuthenticateWithBio);
  }

  getIsUniversalLoad(): boolean {
    return this.getStorage().getItem(keys.isUniversalLoad);
  }

  setIsUniversalLoad(isUniverLoad: boolean) {
    this.getStorage().setItem(keys.isUniversalLoad, isUniverLoad);
  }

  setConfirmSale(confirmSale: any) {
    this.setItemInStorage(keys.confirmSale, confirmSale);
  }

  getConfirmSale() {
    return this.getItemFromStorage(keys.confirmSale)
  }

}
